$(function () {
  $('#users-table').DataTable({
    language: {
      lengthMenu: "Show _MENU_ entries",
    },
    pagingType: "simple_numbers",
    stateSave: true
  });
});